:host {
  display: block;
}

@media screen and (max-width: 979px) {
  .description {
    display: block;
    padding-bottom: 20px;
  }
}